
import GpParser from '../../gpParser';
import { CATEGORIES } from '../../configuration/constants';

import PathImage from './PathImage';
import CustomVideo from './CustomVideo';
import Radio from './Radio';
import ImgBase64 from './ImgBase64';

export default (editor, opt = {}) => {
  GpParser.loadFromList([
    PathImage,
    CustomVideo,
    Radio,
    ImgBase64
  ], CATEGORIES.MEDIA, editor, opt);
}
